const mapData = {
    asset: 'assets/map/lab.png'
};

export default mapData;
